// ===== Spaces (Multiple Desktops) Store =====
// Manages virtual desktop spaces, inspired by Mac OS X Snow Leopard Mission Control.

export const spacesState = $state({
  spaces: [
    { id: 1, name: 'Desktop 1' },
    { id: 2, name: 'Desktop 2' },
  ],
  activeSpaceId: 1,
  missionControlOpen: false,
});

export function switchSpace(id) {
  if (spacesState.spaces.find(s => s.id === id)) {
    spacesState.activeSpaceId = id;
    spacesState.missionControlOpen = false;
  }
}

export function addSpace() {
  const maxId = Math.max(...spacesState.spaces.map(s => s.id), 0);
  const id = maxId + 1;
  spacesState.spaces.push({ id, name: `Desktop ${id}` });
  spacesState.activeSpaceId = id;
}

export function removeSpace(id) {
  if (spacesState.spaces.length <= 1) return;
  const idx = spacesState.spaces.findIndex(s => s.id === id);
  if (idx === -1) return;
  spacesState.spaces.splice(idx, 1);
  if (spacesState.activeSpaceId === id) {
    spacesState.activeSpaceId = spacesState.spaces[Math.max(0, idx - 1)].id;
  }
}

export function reorderSpace(draggedId, targetId) {
  if (draggedId === targetId) return;
  const draggedIdx = spacesState.spaces.findIndex(s => s.id === draggedId);
  const targetIdx = spacesState.spaces.findIndex(s => s.id === targetId);
  if (draggedIdx === -1 || targetIdx === -1) return;

  const [dragged] = spacesState.spaces.splice(draggedIdx, 1);
  spacesState.spaces.splice(targetIdx, 0, dragged);
}

export function toggleMissionControl() {
  spacesState.missionControlOpen = !spacesState.missionControlOpen;
}

/** Restore spaces from a persisted session snapshot. */
export function restoreSpaces(spaces, activeSpaceId) {
  if (!spaces?.length) return;
  spacesState.spaces.splice(0, spacesState.spaces.length, ...spaces);
  spacesState.activeSpaceId = activeSpaceId ?? spaces[0]?.id ?? 1;
}
